/** @jsxImportSource @emotion/react */
import React from "react";

import styled from "@emotion/styled";
import { useBackendPrice } from "utils/price";

const PriceWrap = styled.div`
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  color: #4a4a4a;
  padding: 3px 6px;
  line-height: 1;
  margin-left: 12px;

  .tax,
  .priceperm {
    font-size: 10px;
  }
  .price {
    margin-bottom: 2px;
    font-size: 35px;
    font-weight: 700;
    line-height: 0.9;
    margin-left: -3px;
  }
`;

const Price = ({ count = 1 }) => {
  const { total, sqm, showSqm } = useBackendPrice();

  return (
    <React.Fragment>
      <PriceWrap>
        <div
          style={{ visibility: showSqm ? "visible" : "hidden" }}
          className="priceperm"
        >
          Grundpreis:{sqm}/m2
        </div>
        <div className="price">{total}</div>
        <div className="tax">
          <b>inkl.</b> Mwst. zzgl. <u>Versand</u>
        </div>
      </PriceWrap>
    </React.Fragment>
  );
};

export default Price;
